import React from 'react';
import { Radio } from 'ui/Radio';
import { EProductOrdering } from 'store/modules/bookingManager/subdomains/breakdown/model';

export interface IProductOrderingSelectProps {
  value: EProductOrdering;
  onChange: (value: EProductOrdering) => void;
}

export const ProductOrderingSelect: React.FC<IProductOrderingSelectProps> = ({ value, onChange }) => {
  const showWarning = value === EProductOrdering.SERVICE_DATE;

  return (
    <>
      <p className="font-pt-sans font-bold text-base leading-sm text-black mt-[30px] mb-4">Product Ordering</p>
      <div className="flex">
        <label className="mr-6">
          <Radio checked={value === EProductOrdering.BREAKDOWN} onClick={() => onChange(EProductOrdering.BREAKDOWN)} />
          <span className="ml-2">By Breakdown Order</span>
        </label>

        <label className="mr-6">
          <Radio checked={value === EProductOrdering.SERVICE_DATE} onClick={() => onChange(EProductOrdering.SERVICE_DATE)} />
          <span className="ml-2">By Service Date</span>
        </label>
      </div>
      {showWarning && (
        <div className="mt-1 text-yellow-60 text-sm max-w-[600px]">
          Changing the breakdown order will impact the cancellation policy.<br />
          Please review the cancellation policy and ensure it is correct, before proceeding.
        </div>
      )}
    </>
  );
};
